module.exports = __webpack_public_path__ + "img/post-item_title.943da5d9.png";